import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MigrationUtilityService } from '../../../shared/services/migration-utility.service';
import { StaticPageService } from '../../../shared/services/static-page.service';
import { GeneralService } from '../../../shared/services/general.service';
import { ModalGeneralComponent } from '../../../shared/modals/modal-general/modal-general.component';
import { ClienteSTP } from '../../../shared/models/static-model/bureau.model';
import { InputGeneralRadioButtonComponent } from '../../../shared/inputs/input-general-radio-button/input-general-radio-button.component';
import { InputGeneral } from '../../../shared/inputs/input-general/input-general';
import { LoadGeneralComponent } from '../../../shared/components-generals/load-general/load-general.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-confirm-client',
  templateUrl: './confirm-client.component.html',
  imports: [InputGeneralRadioButtonComponent, InputGeneral, LoadGeneralComponent, TranslateModule],
})
export class ConfirmClientComponent {
  @Input() quotationId: number | null = null;
  name: FormControl = new FormControl(null, [Validators.required]);
  paterno: FormControl = new FormControl(null, [Validators.required]);
  materno: FormControl = new FormControl(null, [Validators.required]);
  rfc: FormControl = new FormControl(null, []);
  stp: FormControl = new FormControl(null, [Validators.required]);
  newCliente: FormControl = new FormControl('Nuevo Cliente');
  clienteSTP: ClienteSTP | null = null;
  newSTP = false;
  loadService = false;

  constructor(
    private dialog: MatDialog,
    private staticPageService: StaticPageService,
    private migrationUtilityService: MigrationUtilityService,
    private generalService: GeneralService,
  ) {
    this.stp.disable();
    this.newCliente.disable();
  }

  public ngOnInit() {
    this.getSTPInitialData();
  }

  public getSTPInitialData(): void {
    this.loadService = true;
    this.staticPageService.getSTPInitialData(this.quotationId ?? 0).subscribe((data) => {
      this.clienteSTP = data;
      this.name.setValue(this.clienteSTP?.nombre);
      this.materno.setValue(this.clienteSTP?.materno);
      this.paterno.setValue(this.clienteSTP?.paterno);
      const rfc = this.clienteSTP?.rfc + (this.clienteSTP?.hcv ? this.clienteSTP.hcv : '');
      this.rfc.setValue(rfc);
      this.rfc.disable();
      this.stp.setValue(this.clienteSTP?.clabE_STP);
      if (this.clienteSTP && this.clienteSTP.iD_CLIENTE !== 0) {
        this.clienteSTP.iS_EXISTING;

        this.newCliente.setValue('Cliente Existente');
        if (this.clienteSTP.clabE_STP.length) {
          this.stp.disable();
          this.newSTP = true;
        }
      }

      this.loadService = false;
    });
  }

  public upsertClient(): void {
    if (this.clienteSTP?.iD_CLIENTE == 0) {
      const body = {
        hcv: this.clienteSTP.hcv,
        idCotizacion: this.quotationId ?? 0,
        idUsuario: this.generalService.getUserId(),
        materno: this.clienteSTP.materno,
        nombre: this.clienteSTP.nombre,
        paterno: this.clienteSTP.paterno,
        rfc: this.clienteSTP.rfc,
      };

      this.staticPageService.upsertClient(body).subscribe((response) => {
        this.stp.setValue(response?.clabE_STP);
        this.newSTP = true;
        this.loadService = false;
        this.confirmClient({
          clabeSTP: response?.clabE_STP ?? '',
          idCliente: response?.iD_CLIENTE ?? 0,
          idCotizacion: this.quotationId ?? 0,
          idUsuario: this.generalService.getUserId(),
          materno: response?.materno ?? '',
          mode: 1,
          nombre: response?.nombre ?? '',
          paterno: response?.paterno ?? '',
        });
      });
    } else {
      this.confirmClient({
        clabeSTP: this.clienteSTP?.clabE_STP ?? '',
        idCliente: this.clienteSTP?.iD_CLIENTE ?? 0,
        idCotizacion: this.quotationId ?? 0,
        idUsuario: this.generalService.getUserId(),
        materno: this.materno?.value ?? '',
        mode: 1,
        nombre: this.name?.value ?? '',
        paterno: this.paterno?.value ?? '',
      });
    }
  }

  public confirmClient(body: {
    clabeSTP: string;
    idCliente: number;
    idCotizacion: number;
    idUsuario: number;
    materno: string;
    mode: number;
    nombre: string;
    paterno: string;
  }): void {
    this.loadService = true;

    this.staticPageService.confirmClient(body).subscribe((response) => {
      this.stp.setValue(response?.clabE_STP);
      this.newSTP = true;
      this.loadService = false;
      this.generalService.viewSnacAlert('Cliente confirmado', 'normal', 'CONFIRMAR CLIENTE');
    });
  }

  private sentEmailModal(): void {
    const dialogRef = this.dialog.open(ModalGeneralComponent, {
      width: '500px',
      height: 'auto',
      disableClose: true,
      autoFocus: false,
      data: {
        Titule: 'Enviar a mail',
        buttonClose: true,
        button: 'Si',
        buttonCancel: 'No',
        text: '¿Confirma el envio de mail de APROBACIÓN?',
        data: {},
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result !== null) {
        if (result) {
          this.sentEmail();
          this.changeQuotationStatus();
        } else {
          this.changeQuotationStatus();
        }
      }
    });
  }

  private sentEmail(): void {
    this.loadService = true;
    this.staticPageService.approveQuotationMail(this.quotationId ?? 0).subscribe((ress) => {
      this.generalService.viewSnacAlert(
        'Cliente confirmado y correo enviado',
        'normal',
        'CONFIRMAR CLIENTE',
      );
    });
  }

  // Cambiar estatus de la cotización a PARA_NOTIFICACION
  private changeQuotationStatus(): void {
    this.loadService = true;
    const userId = localStorage.getItem('userId');
    this.migrationUtilityService
      .changeQuotationStatus({
        quotationId: this.quotationId ?? 0,
        userId: Number(userId),
        newStatus: 'PARA_NOTIFICACION',
        comment: 'Cambio de face Confirmacion(CONFIRMAR CLIENTE)',
      })
      .subscribe((ress) => {
        if (ress) {
          this.loadService = false;
          this.generalService.viewSnacAlert(
            'Cambio de face Confirmacion',
            'normal',
            'CONFIRMAR CLIENTE',
          );
        }
      });
  }
}
